import { SignalsAggregateTimeSeries } from '../model/types';

import * as d3 from 'd3';
import * as d3Collection from 'd3-collection';

/*

    This helpers are functions that allow us to process the data in different scales, or approaches
 */

export const getDataDifferentiated: (data: Array<any>) => Array<any> = (data) =>
  /**
   *  We want to draw the graph with the difference between the values and normalize to zero all the categories
   *  so we use d3.nest that allow us to group data by category and calculate the difference between all the values
   *  after that we use reduce to generate a flat array of data to feed the timeline :)
   */
  d3Collection
    .nest()
    .key((d) => d.category)
    .rollup((group) =>
      group
        .map((d, i) => ({
          ...d,
          value: i === 0 ? d.value : d.value - group[i - 1].value
        }))

        /*

         we are including one more day to complete the steps (see time-helper.ts) given some date range

         here we need to remove it, so we only work with data within the dates range

         */
        .slice(1)
    )
    .entries(data)
    .reduce((next, item) => next.concat(item.value), []);

export const getDataDifferentiatedCustom: (data: Array<any>, prop: string) => Array<any> = (data, prop) =>
  /**
   *  We want to draw the graph with the difference between the values and normalize to zero all the categories
   *  so we use d3.nest that allow us to group data by category and calculate the difference between all the values
   *  after that we use reduce to generate a flat array of data to feed the timeline :)
   */
  d3Collection
    .nest()
    .key((d) => d[prop])
    .rollup((group) =>
      group
        .map((d, i) => ({
          ...d,
          value: i === 0 ? 0 : d.value - group[i - 1].value
        }))

        /*

         we are including one day more to complete the steps (see time-helper.ts) given some date range

         here we need to remove it, so we only work with data within the dates range

         */
        .slice(1)
    )
    .entries(data)
    .reduce((next, item) => next.concat(item.value), []);

export const getCategoryList: (
  data: Array<SignalsAggregateTimeSeries>,
  dictionary?: { [key: string]: any }
) => Array<{ label: string; id: string }> = (data, dictionary?) => {
  // We want to extract the categories of the data with a map
  // And return the label if there is a dictionary
  const map = {};
  data.forEach((element) => {
    const category = element.category;

    map[category] = {
      label: dictionary && dictionary[category] ? dictionary[category] : category,
      id: category
    };
  });
  return Object.keys(map).map((key) => map[key]);
};

export const getDataDifferentiatedNormalized: (differentiatedData: Array<SignalsAggregateTimeSeries>) => Array<any> = (data) =>
  d3Collection
    .nest()
    .key((d) => d.category)
    .rollup((group) => {
      //  get max and min to set the scale that we want to normalize to 0-100
      const maxValue = d3.max(group, (d) => d.value);
      const scale = d3.scaleLinear().domain([0, maxValue]).range([0, 100]);

      return group.map((d, i) => ({
        ...d,
        value: scale(d.value)
      }));
    })
    .entries(data)
    .reduce((next, item) => next.concat(item.value), []);
